import React, { Component, createRef } from "react";

class DateExceptionsModal extends Component {
  constructor(props) {
    super(props);
    let startDate = "";
    let endDate = "";
  
    if (props.student && props.student.date_exceptions && props.student.date_exceptions.trim() !== "") {
      const dateParts = props.student.date_exceptions.split(" - ");
      if (dateParts.length === 2) {
        startDate = dateParts[0].trim();
        endDate = dateParts[1].trim();
      }
    }

    this.state = {
      startDate,
      endDate,
      startDateError: "",
      endDateError: "",
    };

    this.startDateRef = createRef();
    this.endDateRef = createRef();
  }

  componentDidMount() {
    this.initializeDatePickers();
    this.addDatepickerStyle();
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.initializeDatePickers();
      
      if (prevProps.student?.id !== this.props.student?.id) {
        this.updateDateValuesFromProps();
      }
    }
  }

  updateDateValuesFromProps = () => {
    let startDate = "";
    let endDate = "";
    
    if (this.props.student && this.props.student.date_exceptions && this.props.student.date_exceptions.trim() !== "") {
      const dateParts = this.props.student.date_exceptions.split(" - ");
      if (dateParts.length === 2) {
        startDate = dateParts[0].trim();
        endDate = dateParts[1].trim();
      }
    }
    
    this.setState({ 
      startDate, 
      endDate,
      startDateError: "",
      endDateError: "" 
    });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    if (!this.props.isOpen) return;

    if (event.key === 'Escape') {
      this.props.onClose();
    } else if (event.key === 'Enter') {
      this.handleSave(event);
    }
  };  

  addDatepickerStyle = () => {
    const styleId = 'datepicker-z-index-style';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.innerHTML = `
        .ui-datepicker {
          z-index: 9999 !important;
        }
        .modal-overlay {
          z-index: 1000;
        }
        .modal-container {
          z-index: 1001;
        }
      `;
      document.head.appendChild(style);
    }
  };

  initializeDatePickers = () => {
    if (this.startDateRef.current && this.endDateRef.current) {
      $(this.startDateRef.current).datepicker({
        dateFormat: 'mm/dd/y',
        minDate: 0,
        onSelect: (dateText) => {
          this.setState({ startDate: dateText, startDateError: "" });
          $(this.endDateRef.current).datepicker('option', 'minDate', dateText);
        },
        appendTo: "body",
      });

      $(this.endDateRef.current).datepicker({
        dateFormat: 'mm/dd/y',
        minDate: 0,
        onSelect: (dateText) => this.setState({ endDate: dateText, endDateError: "" }),
        appendTo: "body",
      });
      
      if (this.state.startDate) {
        $(this.startDateRef.current).datepicker('setDate', this.state.startDate);
        $(this.endDateRef.current).datepicker('option', 'minDate', this.state.startDate);
      }
      
      if (this.state.endDate) {
        $(this.endDateRef.current).datepicker('setDate', this.state.endDate);
      }
    }
  };

  parseDate = (dateStr) => {
    const [month, day, year] = dateStr.split("/").map(Number);
    return new Date(year + 2000, month - 1, day);
  };

  validateDateFormat = (dateStr) => {
    return /^\d{2}\/\d{2}\/\d{2}$/.test(dateStr);
  };

  handleSave = (event) => {
    if (event) event.preventDefault();

    const { startDate, endDate } = this.state;
    let startDateError = "";
    let endDateError = "";

    if (!startDate) {
      startDateError = "Start Date can't be blank.";
    } else if (!this.validateDateFormat(startDate)) {
      startDateError = "Invalid date format.";
    }

    if (!endDate) {
      endDateError = "End Date can't be blank.";
    } else if (!this.validateDateFormat(endDate)) {
      endDateError = "Invalid date format.";
    }

    if (startDate && endDate && this.validateDateFormat(startDate) && this.validateDateFormat(endDate)) {
      const start = this.parseDate(startDate);
      const end = this.parseDate(endDate);

      if (start > end) {
        endDateError = "End Date cannot be before Start Date.";
      }
    }

    if (startDateError || endDateError) {
      this.setState({ startDateError, endDateError });
      return;
    }

    this.props.onSave(startDate, endDate);
  };

  handleInputChange = (event, field) => {
    let value = event.target.value;

    value = value.replace(/[^0-9/]/g, "");

    if (value.length === 2 || value.length === 5) {
      if (!value.includes("/")) {
        value += "/";
      }
    }

    if (value.length > 8) {
      return;
    }

    this.setState({ [field]: value, [`${field}Error`]: "" });
  };

  render() {
    const { isOpen, onClose, student } = this.props;
    const { startDate, endDate, startDateError, endDateError } = this.state;
    if (!isOpen) return null;

    return (
      <div className="modal-overlay">
        <div className="modal-container">
          <button className="close-button" onClick={onClose} aria-label="Close modal">
            &times;
          </button>
          <div className="modal-body">
            <div style={{ fontSize: "22px", fontWeight: 700, paddingBottom: "20px" }}>
              Date Exceptions
            </div>
            <div style={{ paddingBottom: "10px" }}>
              <span style={{ paddingRight: "5px" }}>Student Name: </span>
              <span style={{ fontWeight: "bold" }}>{student?.full_name}</span>
            </div>

            <div>New Start Date:</div>
            <input
              id="startDate"
              ref={this.startDateRef}
              placeholder="New Start Date"
              value={startDate}
              onChange={(e) => this.handleInputChange(e, "startDate")}
              aria-label="Select new start date"
              maxLength={8}
            />
            {startDateError && <p style={{ color: "red", marginTop: "5px" }}>{startDateError}</p>}

            <div>New End Date:</div>
            <input
              id="endDate"
              ref={this.endDateRef}
              placeholder="New End Date"
              value={endDate}
              onChange={(e) => this.handleInputChange(e, "endDate")}
              aria-label="Select new end date"
              maxLength={8}
            />
            {endDateError && <p style={{ color: "red", marginTop: "5px" }}>{endDateError}</p>}
          </div>
          <button
            className="actionBtn"
            style={{ margin: "30px 30px" }}
            onClick={this.handleSave}
            aria-label="Save new dates"
          >
            Save Dates
          </button>
          <button
            className="aq-button-2 outline-whitebg-dark-grey"
            style={{ float: 'right', margin: "30px 30px", textTransform: 'uppercase' }}
            onClick={onClose}
            aria-label="Cancel and close modal"
          >
            Cancel
          </button>
        </div>
      </div>
    );
  }
}

export default DateExceptionsModal;
